import { cn } from '@/lib/utils';

interface SpinnerProps {
  compact?: boolean;
  className?: string;
}

function Spinner({ compact = false, className }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label="Loading"
      className={cn(
        'inline-block animate-spin rounded-full border-2 border-solid border-[var(--inv-border)] border-t-[var(--inv-accent)]',
        compact ? 'h-4 w-4' : 'h-6 w-6',
        className,
      )}
    />
  );
}

export { Spinner };
